import React from "react";
import { AbsoluteFill, interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { useEnvelope, ThumbIcon, BTN_SHADOW, TEXT_SHADOW, LIKE_BLUE } from "./CTAKit";

// CTA #2 — LIKE thumbs-up punch-in with a "+1" burst. Lower-left by default.
export const CTALike: React.FC<{ left?: number; bottom?: number }> = ({ left = 90, bottom = 110 }) => {
  const { o, s, y } = useEnvelope();
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // thumb does a quick double-tap bounce
  const tap = spring({ fps, frame: frame - Math.round(fps * 0.5), config: { damping: 8, mass: 0.5 } });
  const thumbScale = 1 + 0.18 * Math.max(0, Math.sin((frame - fps * 0.5) * 0.5)) * (frame > fps * 0.5 ? 1 : 0);
  // +1 floats up & fades
  const plusT = frame - Math.round(fps * 0.6);
  const plusO = interpolate(plusT, [0, 6, fps * 1.2], [0, 1, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const plusY = interpolate(plusT, [0, fps * 1.2], [0, -40], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  return (
    <AbsoluteFill style={{ justifyContent: "flex-end", alignItems: "flex-start", paddingLeft: left, paddingBottom: bottom }}>
      <div style={{ position: "relative", opacity: o, transform: `translateY(${y}px) scale(${s})`, display: "flex", alignItems: "center", gap: 14 }}>
        <div
          style={{
            width: 70, height: 70, borderRadius: 999, background: "#2563eb",
            display: "flex", alignItems: "center", justifyContent: "center",
            boxShadow: BTN_SHADOW, transform: `scale(${thumbScale * (0.6 + 0.4 * tap)})`,
          }}
        >
          <ThumbIcon size={38} />
        </div>
        <div style={{ color: "#fff", fontFamily: "Inter, Arial, sans-serif", fontWeight: 900, fontSize: 30, letterSpacing: 1.5, textShadow: TEXT_SHADOW }}>
          LIKE THIS VIDEO
        </div>
        <div style={{ position: "absolute", left: 56, top: -10, opacity: plusO, transform: `translateY(${plusY}px)`, color: LIKE_BLUE, fontFamily: "Inter, Arial, sans-serif", fontWeight: 900, fontSize: 28, textShadow: TEXT_SHADOW }}>
          +1
        </div>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
